import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { to64decode, to64encode } from 'src/app/helpers/base64';
import { localStorageToJsonAsync } from 'src/app/helpers/cookieToJson';
import { addAlert, apiOfflineAsync } from 'src/app/layouts/pages/pages.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FunctionService } from 'src/app/services/function.service';
import { HomeService } from 'src/app/services/home/home.service';
import { UserEnvironmentsService } from 'src/app/services/userEnvironments/user-environments.service';
import { UsersService } from 'src/app/services/users/users.service';
import { getLanguage, getLanguageCookie } from 'src/assets/language';
import { TreeNode } from 'primeng/api';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @Output() clickedCard = new EventEmitter<string>();
  @Input() corporations: TreeNode[] = []

  private subscription: Subscription | undefined;

  properties: any = {}
  selectedItem: any = {};

  corporationsArray: any
  selectedCorporation: any
  isLoadingChooseInstance: boolean = false;
  fliped: any = { slug: ''} 
  indicators: any = {
    line1: [],
    line2: []
  }
  breedArray: any = []
  isLoading: boolean = false
  
  principalCorporation: any


  isShowPrincipal = false;

  iconsAccess: any = [
    {class: 'fas fa-folder-tree', slug: 'business_solutions'},
    {class: 'fas fa-users', slug: 'organizational_structure'},
    {class: 'fas fa-microchip', slug: 'technologies'},
    {class: 'fas fa-list', slug: 'maturity'},
    {class: 'fas fa-sliders', slug: 'standards'},
    {class: 'fas fa-diagram-project', slug: 'project_guideline'},
    {class: 'fas fa-user', slug: 'users'},
    {class: 'fas fa-address-card', slug: 'profiles'},
  ]

  constructor(
    private authService: AuthService,
    private userService: UsersService,
    private userEnvironmentService: UserEnvironmentsService,
    private homeService: HomeService,
    private router: Router,
    private sharedService: FunctionService,
    private navigationService: NavigationService,
    private cdr: ChangeDetectorRef
  ){
    this.principalCorporation = {name: '', uuid: ''}
  }

  async ngOnInit(){
    this.isLoadingChooseInstance = false;
    this.properties = await localStorageToJsonAsync()
    await this.getCardsArrays(),
    await this.getUserCorporations()
  }

  async ngOnChanges(changes: SimpleChanges){
    if(changes['corporations']){
      this.cdr.detectChanges()
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  async ngAfterViewInit() {
    if(!this.scrollContainer || !this.scrollContainer.nativeElement){
      return
    }
    this.scrollContainer.nativeElement.scrollLeft = 0;

    this.subscription = this.sharedService.reloadDashboard$.subscribe(() => {
      Promise.all([
        this.getCardsArrays(),
        this.getUserCorporations()
      ])
      this.getCardsArraysLine2(this.fliped.slug)
    });
  }

  getViewCorporationDashboard(): boolean{
    if(this.corporationsArray?.length < 2 && !this.corporationsArray[0]?.name){
      return false
    }
        
    return true
  }


  scrollLeft(param?: string) {
    const viewportWidth = window.innerWidth;
    const vwToPixels = viewportWidth / 100;

    if(param == 'corporations'){
      this.scrollContainer.nativeElement.scrollLeft -= 25 * vwToPixels;
    }
  }

  scrollRight(param?: string) {
    const viewportWidth = window.innerWidth;
    const vwToPixels = viewportWidth / 100;
  
    if(param == 'corporations'){
      this.scrollContainer.nativeElement.scrollLeft += 25 * vwToPixels;
    }
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  getName(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  async getUserCorporations(){
    try{
      let response = await this.userEnvironmentService.getUserCorporations()
      if(response && response.data){

        response.data.forEach((item: any) => {
          if(item.is_principal){
            this.isShowPrincipal = true
          }
        })

        this.corporationsArray = [...response.data].filter((corporation: any) => !corporation.is_principal)
        this.principalCorporation = [...response.data].filter((corporation: any) => corporation.is_principal)[0]
        const backupArray = [...response.data].filter((corporation: any) => !corporation.is_principal)
        const uuid = to64decode(localStorage.getItem('corporation')).uuid 

        if(uuid == null || uuid == undefined || to64decode(localStorage.getItem('corporation')).is_principal){
          return
        }

        if(this.corporationsArray.length == 1){
          return
        }

        const index = this.corporationsArray.findIndex((corporation: any) => corporation.uuid === uuid);
        this.corporationsArray[0] = backupArray[index]
        this.corporationsArray[index] = backupArray[0]
      }
    }catch(error: any){
      console.error(error.message)
    }
  }

  async chooseCorporation(corporation: any) {
    if (this.properties?.corporation?.uuid === corporation?.uuid || !this.haveAccessCorporation(corporation?.uuid)) {
      return;
    }
    localStorage.setItem('image_corporation', corporation.url);
    delete corporation.url;
    this.isLoadingChooseInstance = true;
    this.selectedCorporation = corporation;
    this.selectedItem = corporation;

    localStorage.removeItem('corporation');
    await this.authService.setCookie({corporation: corporation});

    await this.getMe();
    this.sharedService.triggerGetUserCorporationReload();
  }

  onLoadingComplete() {
    this.isLoadingChooseInstance = false;
    
    // Verifica se tem permissão para a tela atual
    const currentRoute = this.router.url.split('/')[1];
    if (currentRoute && !this.getSystemPermission(currentRoute)) {
      this.navigationService.navigate('/');
      addAlert('danger', getLanguage('without_permission', this.properties.language.lang))

    } else {
      this.navigationService.reload();
    }
  }

  async getMe() {
    try {
      const response = await this.authService.getMe();
      if (![200].includes(response.status)) {
        return this.setAddAlert('danger', response.message)
      }

      this.properties = { ...response.data, ...await localStorageToJsonAsync(true) }
      delete this.properties.corporation.url
      await this.authService.setCookie(this.properties)
      await this.userService.setUserMe(this.properties)
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async choseLine2(card: any){
    if (this.fliped.slug === card.slug) {
      return
    }

    this.clickedCard.emit(card)
    this.fliped = card
    await this.getCardsArraysLine2(card.slug)
    await this.router.navigate([card.url]);
  }

  async getCardsArrays(){
    try {
      const response: any = await this.homeService.getCards('home').toPromise()
      if (response.data.cards) {
        for(let i = 0; i < 4; i++){
          this.indicators.line1[i] = {}
          this.indicators.line1[i].name = response.data.cards[i].name
          this.indicators.line1[i].value = response.data.cards[i].value
          this.indicators.line1[i].slug = response.data.cards[i].slug
          this.indicators.line1[i].url = response.data.cards[i].url
        }
      }
      if (response.data.breed) {
       this.breedArray[0] = response.data.breed.core
       this.breedArray[1] = response.data.breed.corporate
       this.breedArray[2] = response.data.breed.management
      }

    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  async getCardsArraysLine2(fliped: any){
    try {
      const response: any = await this.homeService.getCardsArrays(fliped).toPromise()
      if (response.data) {
        for(let i = 0; i < 4; i++){
          this.indicators.line2[i] = {}
          this.indicators.line2[i].name = response.data[i].name
          this.indicators.line2[i].value = response.data[i].value
          this.indicators.line2[i].slug = response.data[i].slug
        }
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }  

  setAddAlert (type: string = '', text: string = '') {
    addAlert(type, text)
  }

  getNames(name: any){
    return name[to64decode(localStorage.getItem('language')).lang]
  }

  getTitle(): any{
    if(this.fliped.slug == 'environment'){
      return this.getNames({en: 'Environment', pt: 'Ambiente'})
    }
    if(this.fliped.slug == 'corporations'){
      return this.getNames({en: 'Corporation', pt: 'Corporação'})
    }
    if(this.fliped.slug == 'users'){
      return this.getNames({en: 'Users', pt: 'Usuários'})
    }
    if(this.fliped.slug == 'business_solutions'){
      return this.getNames({en: 'Process', pt: 'Processos'})
    }
    return this.getNames({en: 'Enterprise', pt: 'Empresarial'})
  }

  getSystemPermission(screen: string, action?: string){
    return systemPermissionsNew(screen, action)
  }

  haveAccess(uuid: any, screen?: any, action?: any): boolean{
    let flag = false;

    if(this.properties?.me?.is_admin_master){
      return true
    }

    if(this.properties.profile.type == 'environment' && this.getSystemPermission(screen, action)){
      return true
    }

    else {
      this.properties.users_corporations.corporations.forEach((item: any) => {
        if (item.profile && Object.keys(item.profile).length > 0) {
          JSON.parse(item.profile.permissions).forEach((permission: any) => {
            if(item.uuid == uuid && permission['screen'] == screen){
              flag = true
              return
            }
          });
        }
      });
    }

    return flag
  }

  haveAccessCorporation(uuid: any){
    let flag = false

    if(this.properties?.me?.is_admin_master || this.properties?.profile?.type == 'environment'){
      flag = true
    }

    this.properties.users_corporations?.corporations.forEach((item: any) => {
      if(item.uuid == uuid){
        flag = true
      }
    });

    return flag
  }

  async navigate(node: any, route: string) {
    const corporation = {
      uuid: node.uuid,
      name: node.label,
      corporation_name: node.label,
      slug: node.slug,
      is_active: node.is_active,
      is_principal: node.is_principal,
      environment_uuid: this.properties.environment?.uuid,
      corporation_uuid: node.uuid
    }

    localStorage.removeItem('corporation')
    localStorage.setItem('corporation', to64encode(corporation))

    if (to64decode(localStorage.getItem('corporation'))) {
      this.sharedService.triggerReloadPages();
      this.navigationService.navigate(`/${route}`)
    }
  }
}


